import React, { useState, useEffect } from 'react';
import s3 from './wasabi';
import ZoomableImage from './ZoomableImage';
import { useTranslation } from 'react-i18next';

const WasabiImage = ({ bucketName, user_or_folder, hospital_id, file_type, fileName, from, onUrlReady }) => {
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true);
      setError(null);
      
      try {
        if (!bucketName || !user_or_folder || !hospital_id || !file_type || !fileName) {
          setError('Missing required parameters');
          setLoading(false);
          return;
        }

        const cleanFileType = (file_type || '').replace(/^\/+|\/+$/g, '');
        const cleanUserOrFolder = (user_or_folder || '').replace(/^\/+|\/+$/g, '');
        const key = `${cleanUserOrFolder}/${hospital_id}/${cleanFileType}/${fileName}`;

        console.log('Fetching image with params:', {
          bucket: bucketName,
          key,
          endpoint: s3.endpoint.href
        });

        const url = await s3.getSignedUrlPromise('getObject', {
          Bucket: bucketName,
          Key: key,
          Expires: 3600,
          ResponseContentDisposition: 'inline'
        });

        console.log('Image URL generated:', url);
        setImageUrl(url);

        if (onUrlReady) {
          onUrlReady(url);
        }
      } catch (err) {
        console.error('Error fetching image:', err);
        setError(`Failed to fetch image: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [bucketName, user_or_folder, hospital_id, file_type, fileName, onUrlReady]);

  if (error) {
    return (
      <div className="error-message" style={{ padding: '20px', textAlign: 'center', color: '#e74c3c' }}>
        <p>{error}</p>
        <p style={{ fontSize: '12px', marginTop: '10px' }}>Debug Info:</p>
        <pre style={{ fontSize: '11px', textAlign: 'left', background: '#f8f9fa', padding: '10px', borderRadius: '4px' }}>
          {JSON.stringify({
            bucketName,
            user_or_folder,
            hospital_id,
            file_type,
            fileName,
            endpoint: s3.endpoint.href
          }, null, 2)}
        </pre>
      </div>
    );
  }

  if (from === 'bankingInfoPdf') {
    return imageUrl ? null : <div>Loading PDF...</div>;
  }

  if (loading) {
    return (
      <div className="banking-image-loading">
        <div className="banking-spinner"></div>
        <p>{t('bankingInfo.loading')}</p>
      </div>
    );
  }

  return (
    <div className="banking-image-wrapper">
      {imageUrl ? (
        from === 'masterBanners' ? (
          <ZoomableImage src={imageUrl} fileName={fileName} />
        ) : (
          <img
            src={imageUrl}
            alt={fileName || 'Preview image'}
            onLoad={() => console.log('Image loaded successfully')}
            onError={(e) => {
              console.error('Image failed to load:', e);
              setError('Failed to load image');
            }}
          />
        )
      ) : null}
    </div>
  );
};

export default WasabiImage;